import { StyleSheet } from 'react-native'
import { grayBorders, inputTextColor, toqueColor } from '../../../../theme/colors'
import { DOBRA } from '../../../../theme/fonts'

export const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    marginTop: 20,
    alignItems: 'center',
    gap: 8,
  },

  input: {
    borderColor: grayBorders,
    borderWidth: 1,
    borderRadius: 8,
    color: inputTextColor,
    fontFamily: DOBRA,
    height: 42,
    padding: 15,
  },

  searchIcon: {
    right: 13,
    position: 'absolute',
    top: 12,
  },
  containerMic: {
    padding: 17,
    paddingRight: 13,
    position: 'absolute',
    right: 0,
    top: 0,
  },
  searchText: {
    color: toqueColor,
    fontFamily: DOBRA,
    paddingLeft: 17,
  },
})
